/**
 * @generated SignedSource<<31e1cb0336d7185be66f41ad1dd44e09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MATSolvedProblemUserAnswerInput = {
  currentAnswer: number;
  previousAnswer: number;
  sequence: number;
};
export type TaskSolvedProblemUserAnswerUpdateDialog_SolvedProblemUserAnswerHelpText_solvedProblemUserAnswerQuery$variables = {
  input: MATSolvedProblemUserAnswerInput;
};
export type TaskSolvedProblemUserAnswerUpdateDialog_SolvedProblemUserAnswerHelpText_solvedProblemUserAnswerQuery$data = {
  readonly solvedProblemUserAnswer: {
    readonly helpText: string | null;
  };
};
export type TaskSolvedProblemUserAnswerUpdateDialog_SolvedProblemUserAnswerHelpText_solvedProblemUserAnswerQuery = {
  response: TaskSolvedProblemUserAnswerUpdateDialog_SolvedProblemUserAnswerHelpText_solvedProblemUserAnswerQuery$data;
  variables: TaskSolvedProblemUserAnswerUpdateDialog_SolvedProblemUserAnswerHelpText_solvedProblemUserAnswerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MATSolvedProblemUserAnswer",
    "kind": "LinkedField",
    "name": "solvedProblemUserAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "helpText",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskSolvedProblemUserAnswerUpdateDialog_SolvedProblemUserAnswerHelpText_solvedProblemUserAnswerQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskSolvedProblemUserAnswerUpdateDialog_SolvedProblemUserAnswerHelpText_solvedProblemUserAnswerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "939fe2461d07170e27189ee4bbdf62f6",
    "id": null,
    "metadata": {},
    "name": "TaskSolvedProblemUserAnswerUpdateDialog_SolvedProblemUserAnswerHelpText_solvedProblemUserAnswerQuery",
    "operationKind": "query",
    "text": "query TaskSolvedProblemUserAnswerUpdateDialog_SolvedProblemUserAnswerHelpText_solvedProblemUserAnswerQuery(\n  $input: MATSolvedProblemUserAnswerInput!\n) {\n  solvedProblemUserAnswer(input: $input) {\n    helpText\n  }\n}\n"
  }
};
})();

(node as any).hash = "4557460c3db8dd8b1184ff60308f8f88";

export default node;
